export default ngModule => {
  require('./bpoint-service')(ngModule);
  require('./auth-service')(ngModule);
  require('./application-service')(ngModule);
  require('./api-service')(ngModule);
  require('./products-service')(ngModule);
  require('./error-message-service')(ngModule);
  require('./zoho-service')(ngModule);
  require('./operator-service')(ngModule);
  require('./nib-service')(ngModule);
  require('./corporate-service')(ngModule);
  require('./primary-service-needs')(ngModule);
}



// WEBPACK FOOTER //
// ./src/services/index.js